"use client";
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
  IconButton,
  Dialog,
} from "@mui/material";
import "./video.css";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

interface VideoProps {
  homeVideoBanner: any;
}

const Video: React.FC<VideoProps> = ({ homeVideoBanner }) => {
  const [show, setShow] = useState(true);
  const [openDialog, setOpenDialog] = useState(false); // For Dialog state
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      {!openDialog ? (
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 65, sm: 20 },
            left: { xs: 10, sm: 20 },
            zIndex: 1010,
            boxShadow: "1px 1px 4px 1px rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            display: show ? "block" : "none",
          }}
        >
          <CloseIcon
            onClick={() => setShow(false)}
            sx={{
              position: "absolute",
              right: 0,
              color: "white",
              zIndex: 1011,
              cursor: "pointer",
            }}
          />

          <video
            id="myVideo"
            ref={videoRef}
            autoPlay
            muted
            loop
            onClick={handleDialogOpen}
            onContextMenu={(e) => e.preventDefault()} // Prevent right-click menu
            disablePictureInPicture
            controlsList="nodownload noremoteplayback noplaybackrate" // Hide controls
            controls={false} // Disable video controls
            playsInline
            style={{
              borderRadius: "8px",
              width: isSmallScreen ? "140px" : "200px",
              height: isSmallScreen ? "250px" : "350px",
              objectFit: "cover",
              cursor: "pointer",
            }}
          >
            <source
              src={homeVideoBanner?.bannerFile?.secureHttpPath}
              type="video/mp4"
            />
          </video>
        </Box>
      ) : (
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          maxWidth="xs"
          aria-labelledby="video-dialog-title" // Add appropriate ARIA label
          aria-describedby="video-dialog-description" // Optional: Add description
          sx={{
            background: "transparent",
            "& .MuiDialog-paper": {
              maxWidth: { xs: "-webkit-fill-available", sm: "370px" },
              maxHeight: "100%",
            },
            "@media (max-width: 600px)": {
              "& .MuiDialog-paper": {
                width: "100%",
                height: "100%",
                maxHeight: "100%",
                margin: 0,
              },
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <IconButton
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                top: 20,
                left: 20,
                color: "#000",
                background: "#fff",
                borderRadius: "50%",
                zIndex: 1012,
                padding: "4px",
              }}
            >
              <KeyboardBackspaceIcon
                sx={{
                  fontSize: "1.2rem",
                }}
              />
            </IconButton>

            <video
              id="myVideo"
              ref={videoRef}
              autoPlay
              muted={false}
              loop
              controls={false} // Disable video controls
              onContextMenu={(e) => e.preventDefault()} // Prevent right-click menu
              disablePictureInPicture
              controlsList="nodownload noremoteplayback noplaybackrate" // Hide controls
              playsInline
              style={{
                width: "auto",
                height: "100%",
                objectFit: isSmallScreen ? "cover" : "contain", // Show video fully inside the dialog
              }}
            >
              <source
                src={homeVideoBanner?.videoFile?.secureHttpPath}
                type="video/mp4"
              />
            </video>
          </Box>
        </Dialog>
      )}
    </>
  );
};

export default Video;
